<button
  (click)="manualToggleState(); $event.stopPropagation()"
  [matTooltip]="
    isActiveValue
      ? projectIconDataMap[type]?.tooltipForActive
      : projectIconDataMap[type]?.tooltipForInactive
  "
  matTooltipPosition="left"
  class="no-margin no-padding no-border no-background cursor-pointer"
>
  <digires-project-type-image
    [imageURL]="
      isActiveValue
        ? projectIconDataMap[type]?.activeTypeFilterIcon
        : projectIconDataMap[type]?.inActiveTypeFilterIcon
    "
  ></digires-project-type-image>
</button>
